import { render, staticRenderFns } from "./Occupations.vue?vue&type=template&id=d18c4c9c&scoped=true"
import script from "./Occupations.vue?vue&type=script&lang=js"
export * from "./Occupations.vue?vue&type=script&lang=js"
import style0 from "./Occupations.vue?vue&type=style&index=0&id=d18c4c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18c4c9c",
  null
  
)

export default component.exports